import React from "react";
import View from "../../pages/eventList";
import { Box } from "@material-ui/core";
import { Loading } from "../../ui/loader";

class Events extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      past: [],
      joinedUpcoming: [],
      otherUpcoming: [],
      isLicenseMismatch: false,
      mismatchedEventId: null,
    };
  }

  componentDidMount() {
    this.props.getEvents();
    this.props.getUserProfile();
  }

  mapPropsToState = (props) => {
    const past = [];
    const joinedUpcoming = [];
    const otherUpcoming = [];
    if (props.events) {
      const joinedEvents = props.events.joined_events;
      const notJoinedEvents = props.events.not_joined_events;
      if (joinedEvents && joinedEvents.length > 0) {
        for (let event of joinedEvents) {
          if (event.isPast === false) {
            joinedUpcoming.push(event);
          } else {
            past.push(event);
          }
        }
      }
      if (joinedEvents && notJoinedEvents.length > 0) {
        for (let event of notJoinedEvents) {
          if (event.isPast === false) {
            otherUpcoming.push(event);
          } else {
            past.push(event);
          }
        }
      }
    }
    this.setState({
      otherUpcoming: otherUpcoming,
      past: past,
      joinedUpcoming: joinedUpcoming,
    });
  };

  componentDidUpdate(nextProps, nextState, nextContext) {
    if (nextProps.events !== this.props.events) {
      this.setState(this.mapPropsToState(this.props.events));
    }

    return nextState;
  }

  redirectToTeamByID = (e, eventId) => {
    this.props.history.push(`teams/${eventId}`);
  };

  handleCloseModal = () => {
    this.setState({
      isLicenseMismatch: false,
      mismatchedEventId: null,
    });
    this.props.history.push(`events/${this.state.mismatchedEventId}`);
  };
  redirectToEventById = (e, isShowDetails) => {
    const id = e;

    this.props.history.push(`events/${id}`);

  };

  render() {
    const { joinedUpcoming, otherUpcoming, past } = this.state;
    const { events, loading } = this.props.events;

    if (loading) {
      return <Loading loading={loading} />;
    }
    return (
      <Box border="1px solid #dcdcdc" className="rightMemberAreaScreen">
        <Box className="fontStyleHeadingProfile" mb={2}>
          Events
        </Box>
        <View
          onRedirectToEventByID={this.redirectToEventById}
          onRedirectToTeamByID={this.redirectToTeamByID}
          events={events}
          past={past}
          joinedUpcoming={joinedUpcoming}
          otherUpcoming={otherUpcoming}
          isLoading={loading}
          handleCloseModal={this.handleCloseModal}
        />
      </Box>
    );
  }
}

export default Events;
